<template>
  <img :src="logo" class="img-fluid" :alt="alt" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LogoComponent",
  components: {},

  props: {
    logo: {
      required: true,
      type: String,
    },
    alt: {
      required: true,
      type: String,
    },
  },
});
</script>

<style scoped>
img {
  width: 90%;
  max-width: 400px !important;
  padding-bottom: 30px;
}
</style>
